module.exports = __webpack_public_path__ + "static/media/big-screen.349f9061.svg";